/* eslint-disable no-nested-ternary */
/* eslint-disable no-dupe-else-if */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    ICommandBarItemProps,
    Pivot,
    PivotItem,
    DefaultButton,
    PrimaryButton,
    IDropdownOption,
    MessageBarType,
    ActionButton,
    Icon,
    SpinnerSize,
    Spinner,
    PivotLinkSize,
    TooltipHost,
    Stack,
    IDropdownProps,
} from '@fluentui/react';
import React, { useEffect, FC, useState, useRef, FormEvent } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import {
    VirtualizedComboBox,
    TextField,
    Form,
    Panel,
    Section,
    SectionSize,
    Language,
    LayoutContent,
    MessageBar,
    LoadingSpinner,
    changeBreadCrumbAction,
    Dropdown,
    FilteredColumn,
    SortedColumnInfo,
} from '@eta/components';
import { isNullOrUndefined, isNull } from 'util';
import { PermissionClaim } from '@eta/components/dist/authentication/Claim';
import EditERP from './ERP/EditERP';
import RegenerateSecrets from './ERP/RegenerateSecrets';
import AddERP from './ERP/AddERP';
import BlockUser from './User/BlockUser';
import Email from '../../Verification/Components/Email';
import EmailMobile from '../../Verification/Components/EmailMobile';
import Mobile from '../../Verification/Components/Mobile';
import EditAddress from './EditAddress';
import NotificationPreferences from './NotificationPreferences';
import { authService } from '../../Security/Security';
import { ReduxState } from '../../common/reducers';
import { ActivityCodeGrid } from './Grids/ActivityCodeGrid';
import {
    ChangeAppSatusAction,
    getCurrentIntermediary,
    getTaxpayerIntermediaries,
} from '../../ProviderManagement/Redux/Actions';
import {
    updateTaxpayerProfile,
    loadTaxpayerProfile,
    loadTaxpayerNotifications,
    changeUserStatus,
} from '../Redux/Actions';
import {
    GetCurrentTaxpayerResponseDto,
    LanguageTypes,
    UpdateCompanyProfileRequest,
    GetTaxpayerBranchDto,
    GetTaxpayerAddressDto,
    GetRepresentationOfTaxpayerDto,
    TaxpayerBranchRequestDto,
    TaxpayerAddressRequestDto,
    DelegetesStatusUpdateDto,
    ProfileStatus,
    TaxpayerActivityDto,
} from '../../Services/ClientProxy/clientProxy';
import {
    TaxpayerProfileActions,
    Actions,
    Languages,
    Defaults,
    LanguagesCodes,
    NotificationDialogResponseDelay,
} from '../../common/config/constants';
import { ERPGrid } from './Grids/ERPGrid';
import { UsersGrid } from './Grids/UsersGrid';

import {
    GetUserPreferenceResponse,
    NotificationTypes,
} from '../../Services/ClientProxy/NotificationManagementClient';

import './TaxpayerProfile.scss';
import { ServiceCreator } from '../../ProviderManagement/Service/client';
import { requiredItem } from '../../Profile/components/Validation';
import {
    checkArbicLang,
    getBooleanValue,
    isEmptyText,
    isNothing,
} from '../../helpers/utils';
import { getLocalizedName, UIHelpers } from '../../helpers/UIHelpers';
import {
    GetTaxpayerIntermediariesResponseDto,
    IntermediaryDetailsResponseDto,
    ApplicationStatuses,
    ApplicationDto,
} from '../../ProviderManagement/Service/proxy';
import IntermediaryDetails from '../../ProviderManagement/Components/IntermediaryDetails';
import { IntermediariesGrid } from '../../ProviderManagement/Components/IntermediariesGrid';
import { loadReferenceData } from '../../ReferenceData/Redux/Action';
import { RepresentationProvider } from './InviteUser/Context/RepresentationContext';
import InviteUserMain from './InviteUser/InviteUserMain';
import { ClaimsHelper } from '../../helpers/ClaimsHelper';
import ManageIntermediary, {
    Permessions,
} from '../../ProviderManagement/Components/ManageIntermediary';
import DevicesGrid from './POS/DevicesGrid';
import { StatusDialog } from './POS/StatusDialog';
import RegenerateDeviceSecrets from './POS/RegenerateDeviceSecrets';
import {
    CurrentDeviceListItemDto,
    CurrentDeviceListItemDtoQueryListResult,
    DeviceStatus,
} from '../../Services/POS/PosService';
import CommandBarActions from './POS/CommandBarActions';
import { DeviceBulkUpload } from './POS/DeviceBulkUpload';
import RetireDialog from './POS/RetireDialog';

const emptyProfile = new GetCurrentTaxpayerResponseDto();
const emptyNotifications = new GetUserPreferenceResponse();
const emptyIntermediary = new IntermediaryDetailsResponseDto();
const emptyList = new GetTaxpayerIntermediariesResponseDto();

export enum DocumentSubmitType {
    Invoice = 'B2B',
    Reciept = 'B2C',
}

export enum POSDeviceStatusAction {
    Active = 'active',
    Deactive = 'deactive',
}

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
    currentTaxpayerProfile:
        state.taxpayerProfile.currentTaxpayerProfile ?? emptyProfile,
    currentTaxpayerNotifications:
        state.taxpayerProfile.currentNotifications ?? emptyNotifications,
    lastError: state.taxpayerProfile.lastError,
    referenceData: state.referenceData?.taxpayersConfig
        ? {
              optionsCity:
                  state.referenceData?.taxpayersConfig?.cities?.map<IDropdownOption>(
                      (v) => {
                          return { key: v.id || 0, text: v.name || '' };
                      }
                  ) ?? [],
              optionsGovernorate:
                  state.referenceData?.taxpayersConfig?.governorates?.map<IDropdownOption>(
                      (v) => {
                          return {
                              key: v.id || 0,
                              text: `${v.name}` || '',
                          };
                      }
                  ) ?? [],
              optionsCountry:
                  state.referenceData?.taxpayersConfig?.countries?.map<IDropdownOption>(
                      (v) => {
                          return {
                              key: v.id || 0,
                              text: `${v.name}` || '',
                          };
                      }
                  ) ?? [],
          }
        : null,

    intermediary: state.Intermediary.intermediaryDetails ?? emptyIntermediary,
    taxpayerIntermediaries:
        state.Intermediary.taxpayerIntermediaries ?? emptyList,
});

const mapDispatchToProps = {
    dispatchLoadTaxpayerProfile: loadTaxpayerProfile,
    dispatchLoadReferenceData: loadReferenceData,
    dispatchUpdateTaxpayerProfile: updateTaxpayerProfile,
    dispatchLoadTaxpayerNotifications: loadTaxpayerNotifications,
    dispatchUpdateUserStatus: changeUserStatus,
    dispatchLoadIntermediary: getCurrentIntermediary,
    dispatchGetTaxpayerIntermediaries: getTaxpayerIntermediaries,
    dispatchChangeAppSatusAction: ChangeAppSatusAction,
    dispatchChangeBreadcrumb: changeBreadCrumbAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const TaxpayerProfile: FC<PropsFromRedux> = (props: PropsFromRedux) => {
    const {
        currentTaxpayerProfile,
        dispatchLoadReferenceData,
        dispatchLoadTaxpayerProfile,
        dispatchUpdateTaxpayerProfile,
        currentTaxpayerNotifications,
        dispatchLoadTaxpayerNotifications,
        referenceData,
        currentLanguage: propsCurrentLanguage,
        lastError,
        dispatchUpdateUserStatus,
        intermediary,
        taxpayerIntermediaries,
        dispatchLoadIntermediary,
        dispatchGetTaxpayerIntermediaries,
        dispatchChangeAppSatusAction,
        dispatchChangeBreadcrumb,
    } = props;
    const [currentProfile, setCurrentProfile] = useState(
        currentTaxpayerProfile
    );
    const [CurrentIntermediary, setCurrentIntermediary] =
        useState<IntermediaryDetailsResponseDto>(intermediary);
    const [, setTaxpayerIntermediaries] =
        useState<GetTaxpayerIntermediariesResponseDto>();
    const [currentProfileLanguage, setCurrentProfileLanguage] = useState<
        string | undefined
    >(currentTaxpayerProfile.language?.toString());

    const [taxpayerRepresentations, setTaxpayerRepresentations] = useState(
        currentTaxpayerProfile.taxpayersRepresentation
    );
    const [taxpayerBranches, setTaxpayerBranches] =
        useState<IDropdownOption[]>();
    const [selectedBranch, setSelectedBranch] = useState<number | undefined>();
    const [currentBranch, setCurrentBranch] = useState<GetTaxpayerBranchDto>();
    const [representationData, setRepresentationDate] = useState(
        new GetRepresentationOfTaxpayerDto()
    );
    const [currentNotifications, setTaxpayerNotifications] =
        useState(emptyNotifications);
    const [notificationChannelKey, setNotificationChannelKey] =
        useState<string>();
    const [subscriptions, setSubscriptions] = useState<string>();
    const form = useRef(new Form({}));
    const [isFormValid, setIsFormValid] = useState<boolean>(
        form.current.isValid
    );

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const clientId = params?.get('ClientId');

    form.current.onValidityChanged = (isValid) => setIsFormValid(isValid);

    const { t } = useTranslation(['resources', 'common', 'pos']);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [showBulkDialog, setShowBulkDialog] = useState<boolean>(false);
    const [currentLanguage, setCurrentLanguage] = useState<Language>();
    const [showMessageSuccess, setShowMessageSuccess] =
        useState<boolean>(false);
    const [showDownMessageSuccess, setShowDownMessageSuccess] =
        useState<boolean>(false);
    const [showDownMessageFail, setShowDownMessageFail] =
        useState<boolean>(false);
    const [downMessage, setDownMessage] = useState<string>();
    const [showAddIntermediaryLink, setShowAddIntermediaryLink] =
        useState<boolean>(false);
    const [error, setError] = useState<string>();
    const [downError, setDownError] = useState<string>();
    const [isEditable, setEditable] = useState<boolean>(false);
    const [isBranchEditable, setBranchEditable] = useState<boolean>(false);
    const [hideInviteUser, setHideInviteUser] = useState<boolean>(true);
    const [hideAddERP, setHideAddERP] = useState<boolean>(true);
    const [hideEditERP, setHideEditERP] = useState<boolean>(true);
    const [hideAddIntermediary, setHideAddIntermediary] =
        useState<boolean>(true);
    const [intermediaryStatus, setIntermediaryStatus] = useState<
        ApplicationStatuses | undefined
    >(ApplicationStatuses.None);
    const [registerAsIntermediary, setRegisterAsIntermediary] =
        useState<boolean>(false);
    const [isIntermediary, setIsIntermediary] = useState<boolean>(false);

    const [hideSecrets, setHideSecrets] = useState<boolean>(true);
    const [hideVerifyMobile, setHideVerifyMobile] = useState<boolean>(true);
    const [hideVerifyEmail, setHideVerifyEmail] = useState<boolean>(true);
    const [hideVerifyMobileAndEmail, setHideVerifyMobileAndEmail] =
        useState<boolean>(true);
    const [hideBlockUSER, setHideBlockUSER] = useState<boolean>(true);

    const [selectedDevices, setSelectedDevices] = useState<
        CurrentDeviceListItemDto[]
    >([]);
    const [currentDevice, setCurrentDevice] =
        useState<CurrentDeviceListItemDto>();

    const [selectMultiple, setSelectMultiple] = useState<boolean>(false);
    const [currentGrid, setCurrentGrid] = useState<string>('user');

    const [reload, setReload] = useState<boolean>(false);
    const [devices, setDevices] =
        useState<CurrentDeviceListItemDtoQueryListResult>();
    const [canChangeStatus, setCanChangeStatus] = useState<boolean>(false);
    const [canChangeRetire, setcanChangeRetire] = useState<boolean>(false);
    const [deactivateStatus, setDeactivateStatus] =
        useState<POSDeviceStatusAction>(POSDeviceStatusAction.Active);
    const [RetireStatus, setRetireStatus] = useState<POSDeviceStatusAction>(
        POSDeviceStatusAction.Active
    );
    const [devicesFiltered, setDevicesFiltered] = useState<boolean>(false);
    const [devicesResetFilter, setDevicesResetFilter] =
        useState<boolean>(false);
    const [showDeactivateDialog, setShowDeactivateDialog] =
        useState<boolean>(false);
    const [showRetireDialog, setShowRetireDialog] = useState<boolean>(false);

    const [showRegenerateSecrets, setShowRegenerateSecrets] =
        useState<boolean>(false);

    const [, setTooltip] = useState<string | undefined>();
    const [taxpayerActivity, setTaxpayerActivity] = useState<
        TaxpayerActivityDto[] | undefined
    >([]);
    const [hideNotifications, setHideNotifications] = useState<boolean>(true);
    const [hidePopup, setHidePopup] = useState<boolean>(true);
    const [mode, setMode] = useState<'Edit' | 'New' | 'View' | undefined>();
    const representationID = useRef<number>();
    const history = useHistory();

    const hasMngRepres = ClaimsHelper.hasPermission(PermissionClaim.MngRepres);
    const hasMngERP = ClaimsHelper.hasPermission(PermissionClaim.MngERP);
    const hasMngTaxInter = ClaimsHelper.hasPermission(
        PermissionClaim.MngTaxInter
    );
    const hasB2cTagCanMngPOS = ClaimsHelper.isB2cTagCanMngPos();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const registerPOSConfig = getBooleanValue(
        (window as any).REACT_APP_RegisterPOS
    );
    const Tags: IDropdownOption[] = [
        { key: DocumentSubmitType.Invoice, text: t('Doc_Invoices') },
        { key: DocumentSubmitType.Reciept, text: t('Doc_Reciepts') },
    ];

    const [currentTags, setCurrentTags] = useState<string[]>([]);
    const [currentTagsErrorMsg, setCurrentTagsErrorMsg] = useState<string>();

    useEffect(() => {
        if (!isEmptyText(clientId ?? '') && taxpayerRepresentations) {
            const items = taxpayerRepresentations?.filter(
                (item: GetRepresentationOfTaxpayerDto) =>
                    item.userProfileType?.toString() === '2'
            );
            const item =
                items?.find((i) => i.clientID === clientId) ??
                new GetRepresentationOfTaxpayerDto();
            setRepresentationDate(item);
            hideSecretsDialog(false);
        }
    }, [taxpayerRepresentations, clientId]);

    const onRenderTagsLabel = (
        ddProps: IDropdownProps | undefined,
        df?: (renderProps: IDropdownProps | undefined) => JSX.Element | null
    ): JSX.Element | null => {
        if (ddProps) {
            return (
                <Stack
                    horizontal
                    verticalAlign="start"
                    className="TaxpayerTagsLabel"
                >
                    <span>{ddProps.label}&nbsp;&nbsp;</span>
                    <TooltipHost
                        className="TaxpayerTagsTooltip"
                        tooltipProps={{
                            onRenderContent: () => (
                                <div>
                                    <div>
                                        <span className="bold">
                                            {t('Invoices')}&nbsp;&nbsp;
                                        </span>
                                        <span>
                                            {t('B2B_Transactions')}&nbsp;&nbsp;
                                        </span>
                                    </div>
                                    <br />
                                    <br />
                                    <div>
                                        <span className="bold">
                                            {t('Receipts')}&nbsp;&nbsp;
                                        </span>
                                        <span>
                                            {t('B2C_Transactions')}&nbsp;&nbsp;
                                        </span>
                                    </div>
                                </div>
                            ),
                            maxWidth: '350',
                        }}
                    >
                        <Icon iconName="Info" />
                    </TooltipHost>
                </Stack>
            );
        }
        if (df) {
            return df(ddProps);
        }
        return null;
    };

    const onChangeTagsDropDown = (
        _: FormEvent<HTMLDivElement>,
        option: IDropdownOption | undefined
    ): void => {
        if (option) {
            const newTags: string[] = option.selected
                ? [...currentTags, option.key as string]
                : currentTags.filter((key: string) => key !== option.key);
            setCurrentTags(newTags);
            setCurrentTagsErrorMsg(
                newTags.length ? '' : t('Choose_One_Option')
            );
        }
    };

    const hideInviteUserDialog = (hide: boolean) => {
        setHideInviteUser(hide);
        setHidePopup(hide);
        if (hide) representationID.current = undefined;
    };

    const hideAddERPDialog = (hide: boolean) => {
        setHideAddERP(hide);
        setHidePopup(hide);
    };

    const HideAddIntermediaryDialog = (hide: boolean) => {
        setHideAddIntermediary(hide);
        setHidePopup(hide);
    };

    const hideEditERPDialog = (hide: boolean) => {
        setHideEditERP(hide);
        setHidePopup(hide);
    };

    const hideSecretsDialog = (hide: boolean) => {
        setHideSecrets(hide);
        setHidePopup(hide);
    };

    const hideVerifyMobileDialog = (hide: boolean) => {
        setHideVerifyMobile(hide);
        setHidePopup(hide);
    };

    const hideVerifyEmailDialog = (hide: boolean) => {
        setHideVerifyEmail(hide);
        setHidePopup(hide);
    };

    const hideVerifyMobileAndEmailDialog = (hide: boolean) => {
        setHideVerifyMobileAndEmail(hide);
        setHidePopup(hide);
        setEditable(false);
        dispatchLoadReferenceData(propsCurrentLanguage);
    };

    const hideNotificationsDialog = (hide: boolean) => {
        setHideNotifications(hide);
        setHidePopup(hide);
    };

    const hideBlockUSERDialog = (hide: boolean) => {
        setHideBlockUSER(hide);
        setHidePopup(hide);
    };

    const showSuccessMessage = () => {
        setError('');
        setShowMessageSuccess(true);
    };

    const showDownSuccessMessage = (message: string) => {
        setShowDownMessageFail(false);
        setShowDownMessageSuccess(true);
        setDownMessage(message);
    };

    const showErrorMessage = (message?: string) => {
        setShowMessageSuccess(false);
        setError(message);
    };

    const onSetErrorrMessage = (message: string) => {
        hideBlockUSERDialog(true);
        setShowDownMessageFail(true);
        setDownError(message);
        setShowDownMessageSuccess(false);
    };

    const saveAction = (action: string) => {
        setShowDownMessageSuccess(false);
        setShowMessageSuccess(false);
        setShowDownMessageFail(false);
        switch (action) {
            case TaxpayerProfileActions.InviteUser:
                setError(undefined);
                showDownSuccessMessage('resources:Invitation.Sent');
                hideInviteUserDialog(true);
                break;
            case TaxpayerProfileActions.AddERP:
                dispatchLoadTaxpayerProfile();
                showDownSuccessMessage('resources:ErpIsAdded');
                hideAddERPDialog(true);
                break;
            case TaxpayerProfileActions.EditERP:
                dispatchLoadTaxpayerProfile();
                showDownSuccessMessage('resources:EditErp');
                hideEditERPDialog(true);
                break;
            case TaxpayerProfileActions.RegenerateSecrets:
                hideSecretsDialog(true);
                break;
            case TaxpayerProfileActions.VerifyEmail:
                dispatchLoadTaxpayerProfile();
                hideVerifyEmailDialog(true);
                showSuccessMessage();
                setEditable(false);
                break;
            case TaxpayerProfileActions.VerifyMobile:
                dispatchLoadTaxpayerProfile();
                hideVerifyMobileDialog(true);
                showSuccessMessage();
                setEditable(false);
                break;
            case TaxpayerProfileActions.VerifyEmailMobile:
                dispatchLoadTaxpayerProfile();
                hideVerifyMobileAndEmailDialog(true);
                showSuccessMessage();
                setEditable(false);
                break;
            case TaxpayerProfileActions.NotificationPreferences:
                hideNotificationsDialog(true);
                setTimeout(async () => {
                    await dispatchLoadTaxpayerNotifications();
                    showSuccessMessage();
                }, NotificationDialogResponseDelay.Delay);
                break;
            case TaxpayerProfileActions.BlockUSER:
                dispatchLoadTaxpayerProfile();
                showDownSuccessMessage('resources:UserIsBlocked');
                hideBlockUSERDialog(true);
                break;
            case TaxpayerProfileActions.UnBlockUSER:
                dispatchLoadTaxpayerProfile();
                showDownSuccessMessage('resources:UserIsUnBlocked');
                hideBlockUSERDialog(true);
                break;
            case TaxpayerProfileActions.EditUSER:
                dispatchLoadTaxpayerProfile();
                showDownSuccessMessage('resources:UserChanged');
                break;
            case TaxpayerProfileActions.AddIntermediary:
                showDownSuccessMessage('resources:addedIntermediary');
                dispatchGetTaxpayerIntermediaries('', '', Defaults.PageSize, 1);
                setHideAddIntermediary(true);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (devicesResetFilter) {
            setDevicesResetFilter(false);
        }
    }, [devicesResetFilter]);

    // Start Devices Section
    const onDevicesGridBind = (
        dev: CurrentDeviceListItemDtoQueryListResult
    ) => {
        setDevices(dev);
    };

    const setDefaultGrid = () => {
        if (hasMngERP && !isEmptyText(clientId ?? '')) setCurrentGrid('erp');
        else if (hasMngRepres) setCurrentGrid('user');
        else if (hasMngERP) setCurrentGrid('erp');
        else if (hasB2cTagCanMngPOS) setCurrentGrid('pos');
        else if (hasMngTaxInter) setCurrentGrid('intermediary');
    };

    const setSelectedGrid = (type: string) => {
        if (type === 'user' && hasMngRepres) setCurrentGrid(type);
        else if (type === 'erp' && hasMngERP) setCurrentGrid(type);
        else if (type === 'pos' && hasB2cTagCanMngPOS) setCurrentGrid(type);
        else if (type === 'intermediary' && hasMngTaxInter)
            setCurrentGrid(type);
    };

    const onGridChanged = (
        pageIndex: number,
        filteredColumns: FilteredColumn[],
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sortedColumn?: SortedColumnInfo
    ) => {
        const filtersLength = filteredColumns?.length ?? 0;
        setDevicesFiltered(filtersLength > 0);
        return false;
    };

    const onActionClick = (action: string, item: any) => {
        setCurrentDevice(item);
        setSelectMultiple(false);
        if (action === Actions.Reactivate || action === Actions.Deactivate) {
            setShowDeactivateDialog(true);
        } else if (action === Actions.RegenerateSecrets) {
            setShowRegenerateSecrets(true);
        } else if (action === Actions.Edit) {
            history.push({
                pathname: `/TaxpayerProfile/pos/devices/${item.id}`,
                state: { inEditMode: true },
            });
        } else if (action === Actions.Retire) {
            setShowRetireDialog(true);
        }
    };

    const ChangeStatus = () => {
        setShowDeactivateDialog(false);
        setReload(true);
    };

    const DevicesSelectionChanged = (
        currentDevices: CurrentDeviceListItemDto[]
    ) => {
        let canChange = false;
        let canRetire = false;
        let RetireSt = POSDeviceStatusAction.Active;
        let tooltip = '';
        let deactiveSt = POSDeviceStatusAction.Active;

        if (currentDevices.length > 0) {
            const activeDevices = currentDevices.filter(
                (i) => i.status === DeviceStatus.Active
            );
            const inActiveDevices = currentDevices.filter(
                (i) => i.status === DeviceStatus.InActive
            );
            const pendingDevices = currentDevices.filter(
                (i) => i.status === DeviceStatus.Pending
            );

            const isDeactivateByAdmin = currentDevices.some(
                (device) => device.isStatusUpdatedByAdmin === true
            );

            const RetiredDevices = currentDevices.filter(
                (i) => i.status === DeviceStatus.Retired
            );

            const PermRetiredDevices = currentDevices.filter(
                (i) => i.status === DeviceStatus.Retiring
            );

            if (
                (pendingDevices.length > 0 && inActiveDevices.length > 0) ||
                (activeDevices.length > 0 && inActiveDevices.length > 0)
            ) {
                canChange = false;
                tooltip = 'noChangeForMixed';
            } else if (activeDevices.length > 0 || pendingDevices.length > 0) {
                canChange = true;
                deactiveSt = POSDeviceStatusAction.Active;
            } else if (inActiveDevices.length > 0) {
                canChange = !isDeactivateByAdmin;
                deactiveSt = POSDeviceStatusAction.Deactive;
            } else {
                canChange = true;
                tooltip = '';
            }

            if (
                (pendingDevices.length > 0 ||
                    inActiveDevices.length > 0 ||
                    activeDevices.length > 0) &&
                (PermRetiredDevices.length > 0 || RetiredDevices.length > 0)
            ) {
                canRetire = false;
                RetireSt = POSDeviceStatusAction.Active;
            } else if (
                PermRetiredDevices.length > 0 &&
                RetiredDevices.length > 0
            ) {
                canRetire = false;
                RetireSt = POSDeviceStatusAction.Deactive;
            } else if (
                pendingDevices.length > 0 ||
                inActiveDevices.length > 0 ||
                activeDevices.length > 0
            ) {
                canRetire = true;
                RetireSt = POSDeviceStatusAction.Active;
            } else if (PermRetiredDevices.length > 0) {
                canRetire = true;
                RetireSt = POSDeviceStatusAction.Deactive;
            } else if (RetiredDevices.length > 0) {
                canRetire = false;
                RetireSt = POSDeviceStatusAction.Deactive;
            } else {
                canRetire = true;
            }
        }
        return { canChange, tooltip, deactiveSt, canRetire, RetireSt };
    };

    const onDevicesSelectionChanged = (dev: CurrentDeviceListItemDto[]) => {
        setCanChangeStatus(false);
        const res = DevicesSelectionChanged(dev);
        const { canChange, tooltip, deactiveSt, canRetire, RetireSt } = res;
        setCanChangeStatus(canChange);
        setcanChangeRetire(canRetire);
        setTooltip(t(tooltip));
        setDeactivateStatus(deactiveSt);
        setRetireStatus(RetireSt);
        setSelectedDevices(dev);
        return false;
    };

    const ClearFilters = () => {
        setDevicesFiltered(false);
        setDevicesResetFilter(true);
    };

    const getPosCellConfig = [
        { v: `${t('pos:dName')} \n ${t('pos:dSerial')}` },
        { v: `${t('pos:mName')} \n ${t('pos:mVendor')}` },
        { v: `${t('pos:branch')} \n ${t('pos:address')}` },
        { v: `${t('pos:last')} ${t('pos:sentReceipt')}` },
        { v: t('pos:activeFrom') },
        { v: t('pos:activeTo') },
        { v: t('pos:status') },
        { v: `${t('pos:readyToSubmit1')} \n ${t('pos:readyToSubmit2')}` },
    ];

    const posColumns = [
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
    ];

    const mapDevices = (data: any) => {
        const newData = [];
        for (let i = 0; i < data.length; i += 1) {
            const submitStatus = UIHelpers.getNotSubmitReason(
                data[i],
                data[i].status === DeviceStatus.Active
            );
            const { canSubmit, noSubmitReason } = submitStatus;
            const { branchStartDate, branchCeaseDate } = data[i];
            const isActiveBranch = UIHelpers.checkBranchActivity(
                branchStartDate,
                branchCeaseDate
            );
            newData.push({
                name: `${data[i].name} \n ${data[i].serialNumber}`,
                modelName: `${data[i].modelName} \n ${data[i].vendorName}`,
                branch: `${data[i].branchNumber} | ${
                    data[i].branchName ?? ''
                } \n ${data[i].formatedAddress ?? ''}`,
                lastReceiptDate:
                    UIHelpers.getLocalizedDateTime(
                        'Date',
                        data[i].lastReceiptDate,
                        propsCurrentLanguage?.lang
                    ) ?? '',
                activeFrom: UIHelpers.getLocalizedDateTime(
                    'Date',
                    data[i].activeFrom,
                    propsCurrentLanguage?.lang
                ),
                activeTo:
                    UIHelpers.getLocalizedDateTime(
                        'Date',
                        data[i].activeTo,
                        propsCurrentLanguage?.lang
                    ) ?? '',
                status: t(`pos:${data[i].status}`),
                ready: `${
                    canSubmit && isActiveBranch ? t('pos:yes') : t('pos:no')
                } \n ${
                    !isActiveBranch
                        ? t('pos:branchIsNotActive')
                        : (noSubmitReason &&
                              isActiveBranch &&
                              t(`pos:${noSubmitReason}`)) ??
                          ' '
                }`,
            });
        }
        return newData;
    };

    const Export = () => {
        let data: any = [];
        const devs =
            selectedDevices.length > 0 ? selectedDevices : devices?.data;
        data = mapDevices(devs);
        UIHelpers.downloadExcel(
            data,
            t('pos:Devices'),
            getPosCellConfig,
            propsCurrentLanguage?.lang,
            posColumns
        );
    };

    const onCommandBarActionClick = (type: string) => {
        switch (type) {
            case 'pos':
                history.push('/TaxpayerProfile/pos/devices/new');
                break;
            case 'user':
                hideInviteUserDialog(false);
                setMode('New');
                break;
            case 'erp':
                hideAddERPDialog(false);
                break;
            case 'intermediary':
                HideAddIntermediaryDialog(false);
                break;
            case 'none':
                onCommandBarActionClick(currentGrid);
                break;
            case 'Export':
                Export();
                break;
            case 'Deactivate':
                setShowDeactivateDialog(true);
                setSelectMultiple(true);
                break;
            case 'Retire':
                setShowRetireDialog(true);
                setSelectMultiple(true);
                break;
            case 'ClearFilters':
                ClearFilters();
                break;
            default:
                break;
        }
    };
    // End Devices Section
    const onChangeBranch = (key?: number) => {
        const currentTaxpyerBranch =
            currentTaxpayerProfile.taxpayerBranchs &&
            currentTaxpayerProfile.taxpayerBranchs.find(
                (item: GetTaxpayerBranchDto) => item.branchID === key
            );

        setSelectedBranch(key);

        setCurrentBranch(currentTaxpyerBranch);

        setTaxpayerActivity(currentTaxpyerBranch?.taxpayerActivities);
    };

    const formattedAddress = (address?: GetTaxpayerAddressDto) => {
        // const address = currentBranch?.address;
        return currentLanguage?.lang !== Languages.En
            ? address?.formattedAddressAr
            : address?.formattedAddressEn;
    };

    const primaryAddress = () => {
        const mainBranch = currentTaxpayerProfile?.taxpayerBranchs?.find(
            (item: GetTaxpayerBranchDto) => item.isMainBranch === true
        );
        return formattedAddress(mainBranch?.address);
    };

    const getConfigs = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const Config = await client.getConfig();
        const DocEnabled = Config.claims?.find(
            (x) => x.code === Permessions.CanViewDocument
        )?.enabled;
        const EnabledArr =
            Config.claims?.filter((x) => x.enabled === true) ?? [];
        if (!DocEnabled || EnabledArr.length === 0)
            setShowAddIntermediaryLink(false);
        else setShowAddIntermediaryLink(true);
    };

    useEffect(() => {
        if (
            referenceData === null ||
            propsCurrentLanguage !== currentLanguage
        ) {
            setShowDownMessageSuccess(false);
            setShowDownMessageFail(false);
            setCurrentLanguage(propsCurrentLanguage);
            dispatchLoadReferenceData(propsCurrentLanguage);
            setDefaultGrid();
            getConfigs();
        }
    }, [
        referenceData,
        dispatchLoadReferenceData,
        getConfigs,
        propsCurrentLanguage,
        currentLanguage,
    ]);

    useEffect(() => {
        if (hidePopup) {
            if (lastError) {
                setShowMessageSuccess(false);
            }
            showErrorMessage(lastError?.serviceError?.toString());
        }
    }, [lastError]);

    const setIntermediary = () => {
        const id = intermediary?.id;
        const appDto = new ApplicationDto();
        const recentApplication = intermediary?.recentApplication;

        setRegisterAsIntermediary(true);
        setIsIntermediary(false);
        if (id && id > 0) {
            setIsIntermediary(true);
            setRegisterAsIntermediary(false);
        } else if (
            !isNullOrUndefined(recentApplication) &&
            recentApplication !== appDto
        ) {
            if (
                recentApplication?.status === ApplicationStatuses.Rejected ||
                recentApplication?.status === ApplicationStatuses.Pending
            ) {
                setIntermediaryStatus(recentApplication?.status);
                setRegisterAsIntermediary(
                    recentApplication?.status === ApplicationStatuses.Rejected
                );
            }
        } else {
            setRegisterAsIntermediary(true);
        }
    };

    useEffect(() => {
        if (
            intermediary === emptyIntermediary ||
            CurrentIntermediary === intermediary
        ) {
            setIsLoading(true);
            dispatchLoadIntermediary();
        } else {
            setCurrentIntermediary(intermediary);
            dispatchChangeBreadcrumb([]);
        }
        setIntermediary();
    }, [intermediary, dispatchLoadIntermediary]);

    useEffect(() => {
        if (taxpayerIntermediaries === emptyList) {
            setIsLoading(true);
            dispatchGetTaxpayerIntermediaries('', '', Defaults.PageSize, 1);
        } else {
            setTaxpayerIntermediaries(taxpayerIntermediaries);
        }
    }, [taxpayerIntermediaries, dispatchGetTaxpayerIntermediaries]);

    useEffect(() => {
        if (currentTaxpayerProfile === emptyProfile) {
            setIsLoading(true);
            dispatchLoadTaxpayerProfile();
        } else {
            setIsLoading(false);
            if (!isEditable) {
                setCurrentProfile(currentTaxpayerProfile);
                setCurrentTags(
                    currentTaxpayerProfile?.tags
                        ?.split(',')
                        .filter((element) => element) ?? []
                );
                setCurrentProfileLanguage(
                    currentTaxpayerProfile?.language?.toString()
                );
            }
        }

        let branches = currentTaxpayerProfile.taxpayerBranchs
            ? currentTaxpayerProfile.taxpayerBranchs.map(
                  (item: {
                      branchID?: number;
                      sourceAddress?: string;
                      branchNumber?: number;
                      nameSecondaryLang?: string;
                  }) => ({
                      key: (item && item.branchID) || 0,
                      text:
                          item &&
                          `${item.branchNumber} / ${
                              isNullOrUndefined(item.nameSecondaryLang)
                                  ? item.sourceAddress
                                  : item.nameSecondaryLang
                          }`,
                  })
              )
            : [];

        branches = branches.sort((a, b) =>
            Number(a.text.split('/')[0]) > Number(b.text.split('/')[0]) ? 1 : -1
        );

        if (branches.length === 0) {
            setBranchEditable(true);
        } else {
            setBranchEditable(false);
        }

        const firstBranch = branches && branches[0] && branches[0].key;

        setTaxpayerBranches(branches);
        setTaxpayerRepresentations(
            currentTaxpayerProfile.taxpayersRepresentation
        );
        onChangeBranch(firstBranch);
        form.current.SetValidity('email', true);
        form.current.SetValidity('mobile', true);
    }, [currentTaxpayerProfile, dispatchLoadTaxpayerProfile]);

    useEffect(() => {
        if (
            currentTaxpayerNotifications === emptyNotifications ||
            propsCurrentLanguage !== currentLanguage
        ) {
            setIsLoading(true);
            setCurrentLanguage(propsCurrentLanguage);
            dispatchLoadTaxpayerNotifications();
        } else {
            setIsLoading(false);
        }
        const currntNots = currentTaxpayerNotifications?.result;
        const notification = currntNots && currntNots[0];
        const Subscriptions = [];
        const recipients = notification?.recipientNotificationPreferences;
        if (recipients) {
            setSubscriptions('');
            for (let i = 0; i < recipients?.length; i += 1) {
                const notify = recipients[i];
                if (notify) {
                    switch (notify.notificationTypeId) {
                        case NotificationTypes.DocumentReceived:
                            Subscriptions.push(
                                t('form.Notification.DocumentReceived')
                            );
                            break;
                        case NotificationTypes.ReceiveDownloadReady:
                            Subscriptions.push(t('DocumentPackageReady'));
                            break;
                        case NotificationTypes.ReceiptPackageDownloadReady:
                            Subscriptions.push(
                                t('form.Notification.ReceiptPackageReady')
                            );
                            break;
                        case NotificationTypes.DocumentCancelled:
                            Subscriptions.push(
                                t('form.Notification.DocumentCancelled')
                            );
                            break;
                        case NotificationTypes.DocumentRejected:
                            Subscriptions.push(
                                t('form.Notification.DocumentRejected')
                            );
                            break;
                        case NotificationTypes.DocumentValidated:
                            Subscriptions.push(
                                t('form.Notification.DocumentValidated')
                            );
                            break;
                        case NotificationTypes.CodeUsageApproved:
                            Subscriptions.push(
                                t('form.Notification.CodesRequests')
                            );
                            break;
                        case NotificationTypes.PosDataValidation:
                            Subscriptions.push(
                                t('form.Notification.PosDataValidation')
                            );
                            break;
                        case NotificationTypes.ReceiptValidated:
                            Subscriptions.push(
                                t('form.Notification.ReceiptValidated')
                            );
                            break;
                        case NotificationTypes.ReceiptProcessResult:
                            Subscriptions.push(
                                t('form.Notification.ReceiptProcessResult')
                            );
                            break;
                        case NotificationTypes.ReceiptReceived:
                            Subscriptions.push(
                                t('form.Notification.ReceiptReceived')
                            );
                            break;
                        case NotificationTypes.ReceiptSummary:
                            Subscriptions.push(
                                t('form.Notification.TaxpayerReceiptSummary')
                            );
                            break;
                        default:
                            break;
                    }
                }
            }
            const sub = Subscriptions.join(', ');
            setSubscriptions(sub);
        }
        const notificationChannel = notification?.notificationChannel;
        if (notificationChannel) {
            const NotificationChannelKey = checkArbicLang(currentLanguage?.lang)
                ? notificationChannel.nameSecondaryLang
                : notificationChannel.namePrimaryLang;
            setNotificationChannelKey(NotificationChannelKey);
        }

        setTaxpayerNotifications(currentTaxpayerNotifications);
    }, [
        currentTaxpayerNotifications,
        loadTaxpayerNotifications,
        propsCurrentLanguage,
        currentLanguage,
    ]);

    const onChangeEdit = (value: boolean) => {
        setEditable(value);
    };

    const onChangeBranchEdit = (value: boolean) => {
        setBranchEditable(value);
    };

    const cancelForm = () => {
        dispatchLoadTaxpayerProfile();
        setEditable(false);
        setIsFormValid(true);
    };

    const saveForm = async (
        address?: GetTaxpayerAddressDto,
        branchName?: string
    ) => {
        setIsSaving(true);
        if (form.current.isValid) {
            try {
                setIsLoading(true);
                const request = new UpdateCompanyProfileRequest();
                request.email = currentProfile.email;
                request.mobileNo = currentProfile.mobileNo;
                request.namePrimaryLang = currentProfile.namePrimaryLang;
                request.preferredLanguage =
                    currentProfileLanguage === LanguagesCodes.En
                        ? LanguageTypes.En
                        : LanguageTypes.Ar;
                request.submissionTag = currentTags
                    ?.filter((element) => element)
                    .join(',');
                if (address) {
                    const branch = currentProfile.taxpayerBranchs?.find(
                        (item: GetTaxpayerBranchDto) =>
                            item.branchID === currentBranch?.branchID
                    );
                    if (branch) {
                        const branchRequest = new TaxpayerBranchRequestDto();
                        branchRequest.branchID = branch.branchID ?? 0;
                        branchRequest.branchName = branchName;
                        const addressDto = new TaxpayerAddressRequestDto();
                        addressDto.streetName = address?.streetName;
                        addressDto.streetName2 = address.streetName2;
                        addressDto.buildingNo = address?.buildingNo;
                        addressDto.countryID = address?.countryID;
                        addressDto.floorNo = address?.floorNo;
                        addressDto.flatNo = address?.flatNo;
                        addressDto.additionalInformation =
                            address?.additionalInformation;
                        addressDto.postalCode = address?.postalCode;
                        addressDto.countryCode = address?.countryCode;
                        if (address?.countryCode === 'EG') {
                            addressDto.cityID = address?.cityID;
                            addressDto.governorateID = address?.governorateID;
                        } else {
                            addressDto.foreignCityName =
                                address?.foreignCityName;
                            addressDto.foreignGovernorateName =
                                address?.foreignGovernorateName;
                        }
                        branchRequest.address = addressDto;
                        const updatebranches: TaxpayerBranchRequestDto[] = [];
                        updatebranches.push(branchRequest);
                        request.taxpayerBranchs = updatebranches;
                    }
                }
                const Response = await dispatchUpdateTaxpayerProfile(request);

                if (isNull((await Response.payload).lastError)) {
                    if (
                        currentProfile?.mobileNo !==
                            currentTaxpayerProfile.mobileNo &&
                        currentProfile?.email === currentTaxpayerProfile.email
                    ) {
                        setHideVerifyMobile(false);
                    } else if (
                        currentProfile?.email !==
                            currentTaxpayerProfile.email &&
                        currentProfile?.mobileNo ===
                            currentTaxpayerProfile.mobileNo
                    ) {
                        setHideVerifyEmail(false);
                    } else if (
                        currentProfile?.email !==
                            currentTaxpayerProfile.email &&
                        currentProfile?.mobileNo !==
                            currentTaxpayerProfile.mobileNo
                    ) {
                        setHideVerifyMobileAndEmail(false);
                    } else {
                        setEditable(false);
                        dispatchLoadTaxpayerProfile();
                        setBranchEditable(false);
                        showSuccessMessage();
                    }
                }
                setIsSaving(false);
            } catch (exception) {
                showErrorMessage(exception?.message);
                setIsSaving(false);
            }
            setIsLoading(false);
        }
        history.push('/TaxpayerProfile');
    };

    const DefaultLanguage = [
        { key: LanguagesCodes.En, text: t('constants.English') },
        { key: LanguagesCodes.Ar, text: t('constants.Arabic') },
    ];

    const inviteUser = {
        key: 'Invite User',
        text: t('TaxpayerUserGrid.InviteUser'),
        iconProps: { iconName: 'AddFriend' },
        onClick: () => {
            hideInviteUserDialog(false);
            setMode('New');
        },
    };

    const registerERP = {
        key: 'Register Erp',
        text: t('TaxpayerUserGrid.RegisterErp'),
        iconProps: { iconName: 'PlugConnected' },
        onClick: () => hideAddERPDialog(false),
    };

    const addIntermediary = {
        key: 'Add Intermediary',
        text: t('form.Taxpayer.AddIntermediary'),
        iconProps: { iconName: 'Link' },
        onClick: () => HideAddIntermediaryDialog(false),
    };

    const registerPOS = {
        key: 'RegisterPOS',
        text: t('pos:RegisterPOS2'),
        iconProps: { iconName: 'Add' },
        onClick: () => history.push('/TaxpayerProfile/pos/devices/new'),
    };

    const registerBulkPOS = {
        key: 'RegisterBulkPOS',
        text: t('pos:RegisterBulkPOS'),
        iconProps: { iconName: 'BulkUpload' },
        onClick: () => setShowBulkDialog(true),
    };

    const getItems = () => {
        const _items: ICommandBarItemProps[] = [];
        if (hasMngRepres) _items.push(inviteUser);
        if (hasMngERP) _items.push(registerERP);
        if (hasMngTaxInter && showAddIntermediaryLink)
            _items.push(addIntermediary);

        if (hasB2cTagCanMngPOS && registerPOSConfig) {
            _items.push(registerPOS);
            _items.push(registerBulkPOS);
        }
        return _items;
    };

    const onERPGridAction = (
        action: string,
        item: GetRepresentationOfTaxpayerDto
    ) => {
        setRepresentationDate(item);
        switch (action) {
            case Actions.EditERP:
                hideEditERPDialog(false);
                break;
            case Actions.RegenerateSecrets:
                hideSecretsDialog(false);
                break;
            default:
                break;
        }
    };

    const onUSERGridAction = async (
        action: string,
        item: GetRepresentationOfTaxpayerDto
    ) => {
        setRepresentationDate(item);
        setShowDownMessageFail(false);
        switch (action) {
            case Actions.BlockUSER:
                hideBlockUSERDialog(false);
                break;
            case Actions.UnBlockUSER:
                hideBlockUSERDialog(false);
                break;
            case Actions.EditUSER:
                hideInviteUserDialog(false);
                setMode('Edit');
                representationID.current = item.taxpayerRepresentationID;
                break;
            case Actions.ViewDetails:
                hideInviteUserDialog(false);
                setMode('View');
                representationID.current = item.taxpayerRepresentationID;
                break;
            default:
                break;
        }
    };

    const blockUSER = async (request: DelegetesStatusUpdateDto) => {
        setHideBlockUSER(true);
        const response = await dispatchUpdateUserStatus(request);
        if (isNull((await response.payload).lastError)) {
            switch (request.delegeteStatusDto?.[0].status) {
                case ProfileStatus.Active:
                    saveAction(TaxpayerProfileActions.UnBlockUSER);
                    break;
                case ProfileStatus.Blocked:
                    saveAction(TaxpayerProfileActions.BlockUSER);
                    break;
                default:
                    break;
            }
        } else {
            onSetErrorrMessage(
                (await response.payload).lastError?.serviceError?.toString() ||
                    ''
            );
        }
    };

    const GetDateOnly = (date?: Date): number => {
        return (date ? new Date(date) : new Date()).setHours(0, 0, 0, 0);
    };

    const CheckIFActiveBranch = (fromDate?: Date, toDate?: Date): boolean => {
        const now = GetDateOnly();
        const from = GetDateOnly(fromDate);
        const to = GetDateOnly(toDate);

        return from <= now && (isNothing(toDate) || to > now);
    };

    return (
        <LayoutContent className="myprofile" loading={isLoading}>
            {showMessageSuccess && (
                <MessageBar
                    messageBarType={MessageBarType.success}
                    isMultiline={false}
                    onDismiss={() => setShowMessageSuccess(false)}
                    duration={Defaults.AutoDismissPeriod}
                >
                    {t('form.response.success')}
                </MessageBar>
            )}
            {error && (
                <MessageBar
                    messageBarType={MessageBarType.blocked}
                    isMultiline={false}
                    onDismiss={() => setError('')}
                    truncated
                >
                    {error}
                </MessageBar>
            )}
            <div className="taxpayerHeader">
                <div className="header_Title">
                    <span className="registerNO">
                        {currentProfile?.registrationNumber}
                    </span>
                    <span className="taxpayerName">
                        {getLocalizedName(
                            currentProfile?.namePrimaryLang ?? '',
                            currentProfile?.nameSecondaryLang ?? '',
                            currentLanguage
                        )}
                    </span>
                </div>
                <Pivot className="taxpayerTabs" linkSize={PivotLinkSize.large}>
                    <PivotItem headerText={t('profileDetails')}>
                        <Panel
                            title={t('TaxPayer.GeneralInformation')}
                            allowEdition={ClaimsHelper.hasPermission(
                                PermissionClaim.MngContact
                            )}
                            editable={isEditable}
                            editTitle={t('common:edit')}
                            editText={t('common:edit')}
                            onChangeEdit={onChangeEdit}
                            footer={
                                <div className="taxPayer-btns">
                                    <DefaultButton
                                        text={t('common:cancel')}
                                        onClick={() => cancelForm()}
                                    />
                                    <PrimaryButton
                                        text={t('common:save')}
                                        onClick={() => saveForm()}
                                        disabled={isSaving || !isFormValid}
                                    >
                                        {isSaving && (
                                            <Spinner size={SpinnerSize.small} />
                                        )}
                                    </PrimaryButton>
                                </div>
                            }
                        >
                            <div
                                className={`editTaxpayer ${
                                    isEditable ? 'isEditable' : null
                                }`}
                            >
                                <div className="bodyLine detailsTaxPayer">
                                    <TextField
                                        label={t(
                                            'form.TaxPayer.CompanyName(EN)'
                                        )}
                                        value={currentProfile?.namePrimaryLang}
                                        disabled
                                        readOnly={isEditable}
                                        title={currentProfile?.namePrimaryLang}
                                    />
                                    <TextField
                                        label={t(
                                            'form.TaxPayer.CompanyName(Arabic)'
                                        )}
                                        value={
                                            currentProfile?.nameSecondaryLang
                                        }
                                        disabled
                                        readOnly={isEditable}
                                        title={
                                            currentProfile?.nameSecondaryLang
                                        }
                                    />
                                    <TextField
                                        label={t(
                                            'form.TaxPayer.RegistrationNumber'
                                        )}
                                        value={
                                            currentProfile?.registrationNumber
                                        }
                                        disabled
                                        readOnly={isEditable}
                                        title={
                                            currentProfile?.registrationNumber
                                        }
                                    />
                                    <Dropdown
                                        selectedKey={currentProfileLanguage}
                                        onChange={(_, option) =>
                                            setCurrentProfileLanguage(
                                                option?.key.toString()
                                            )
                                        }
                                        options={DefaultLanguage}
                                        readOnly={!isEditable}
                                        label={t(
                                            'form.TaxPayer.DefaultLanguage'
                                        )}
                                    />
                                </div>
                                <div className="bodyLine regiseteration">
                                    <TextField
                                        label={t(
                                            'form-components.RegiseterationDate'
                                        )}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'Date',
                                            currentProfile?.operationStartDate,
                                            propsCurrentLanguage.langIso4
                                        )}
                                        disabled
                                    />
                                    <TextField
                                        label={t('form-components.ClosureDate')}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'Date',
                                            currentProfile?.operationEndDate,
                                            propsCurrentLanguage.langIso4
                                        )}
                                        disabled
                                    />
                                    <TextField
                                        label={t('common:primaryAddress')}
                                        value={primaryAddress()}
                                        disabled
                                        toolTip={t(
                                            'ToolTip.PrimaryBranchAddress'
                                        )}
                                    />
                                </div>
                                <div className="bodyLine regiseteration">
                                    <Dropdown
                                        selectedKeys={currentTags}
                                        selectedKey={currentTags[0] ?? -1}
                                        options={Tags}
                                        label={t('Documents_to_submit')}
                                        multiSelect
                                        onChange={onChangeTagsDropDown}
                                        readOnly={
                                            !isEditable ||
                                            currentProfile.readOnlyTags
                                        }
                                        required={
                                            isEditable &&
                                            !currentProfile.readOnlyTags
                                        }
                                        onRenderLabel={onRenderTagsLabel}
                                        errorMessage={currentTagsErrorMsg}
                                        validationFunc={(v) =>
                                            requiredItem(t, v, '')
                                        }
                                        onValidationChange={(isValid) =>
                                            form.current.SetValidity(
                                                'DocumentsToSubmit',
                                                isValid
                                            )
                                        }
                                    />
                                </div>
                                <div className="bodyLine2 notifications">
                                    <div className="section">
                                        <Section
                                            size={SectionSize.h3}
                                            title={t(
                                                'form.TaxPayer.Notifications'
                                            )}
                                            actionButton={<></>}
                                        />
                                        {ClaimsHelper.hasPermission(
                                            PermissionClaim.MngContact
                                        ) && (
                                            <ActionButton
                                                className="manage"
                                                iconProps={{
                                                    iconName: 'Settings',
                                                }}
                                                onClick={async () => {
                                                    const Result =
                                                        await dispatchLoadTaxpayerNotifications();
                                                    if (Result) {
                                                        hideNotificationsDialog(
                                                            false
                                                        );
                                                    }
                                                }}
                                            >
                                                {t('form.TaxPayer.Manage')}
                                            </ActionButton>
                                        )}
                                    </div>

                                    <div className="section">
                                        <Section
                                            size={SectionSize.h3}
                                            title={t(
                                                'form.TaxPayer.NotificationDelivery'
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="bodyLine channelSubscrip">
                                    <TextField
                                        label={t('form.TaxPayer.Channel')}
                                        value={
                                            isNullOrUndefined(
                                                notificationChannelKey
                                            )
                                                ? t(
                                                      'resources:NotificationEmail'
                                                  )
                                                : notificationChannelKey
                                        }
                                        disabled
                                        title={notificationChannelKey}
                                    />
                                    <TextField
                                        label={t('form.TaxPayer.Subscriptions')}
                                        value={subscriptions}
                                        disabled
                                        title={subscriptions}
                                    />

                                    <TextField
                                        label={t('form.TaxPayer.E-mailAddress')}
                                        value={currentProfile?.email}
                                        onChange={(_, v) =>
                                            setCurrentProfile(
                                                new GetCurrentTaxpayerResponseDto(
                                                    {
                                                        ...currentProfile,
                                                        email: v ?? '',
                                                    }
                                                )
                                            )
                                        }
                                        title={currentProfile?.email}
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('form.TaxPayer.E-mailAddress')
                                            )
                                        }
                                        onValidationChange={(isValid) =>
                                            form.current.SetValidity(
                                                'email',
                                                isValid
                                            )
                                        }
                                        disabled={!isEditable}
                                        required={isEditable}
                                    />
                                    <TextField
                                        label={t('form.TaxPayer.MobileNumber')}
                                        className="mobilePhone"
                                        value={currentProfile?.mobileNo}
                                        title={currentProfile?.mobileNo}
                                        onChange={(_, v) =>
                                            setCurrentProfile(
                                                new GetCurrentTaxpayerResponseDto(
                                                    {
                                                        ...currentProfile,
                                                        mobileNo: v ?? '',
                                                    }
                                                )
                                            )
                                        }
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('form.TaxPayer.MobileNumber')
                                            )
                                        }
                                        onValidationChange={(isValid) =>
                                            form.current.SetValidity(
                                                'mobileNo',
                                                isValid
                                            )
                                        }
                                        disabled={!isEditable}
                                        required={isEditable}
                                    />
                                </div>
                            </div>
                        </Panel>

                        <div className="VerifyOtpNotification">
                            {showDownMessageSuccess && (
                                <MessageBar
                                    messageBarType={MessageBarType.success}
                                    isMultiline={false}
                                    onDismiss={() =>
                                        setShowDownMessageSuccess(false)
                                    }
                                    duration={Defaults.AutoDismissPeriod}
                                >
                                    {t(downMessage || 'form.response.success')}
                                </MessageBar>
                            )}
                            {showDownMessageFail && (
                                <MessageBar
                                    messageBarType={MessageBarType.blocked}
                                    isMultiline={false}
                                    onDismiss={() =>
                                        setShowDownMessageFail(false)
                                    }
                                >
                                    {downError}
                                </MessageBar>
                            )}
                        </div>
                        <div className="panel">
                            <div className="represenHeader">
                                <div className="titleBlock">
                                    <Section
                                        title={t(
                                            'form.actions.Representatives'
                                        )}
                                        size={SectionSize.h2}
                                    />
                                    {selectedDevices &&
                                        selectedDevices.length > 0 && (
                                            <div className="Selected">
                                                <div className="completed">
                                                    <Icon iconName="StatusCircleCheckmark" />
                                                </div>
                                                <span>
                                                    {t('Selected')} :{' '}
                                                    <b>
                                                        {selectedDevices.length}
                                                    </b>{' '}
                                                    <span className="secondary">
                                                        /{' '}
                                                        {devices?.data?.length}
                                                    </span>
                                                </span>
                                            </div>
                                        )}
                                </div>
                                <CommandBarActions
                                    selectedDevices={selectedDevices}
                                    deactivateStatus={deactivateStatus}
                                    canChangeStatus={canChangeStatus}
                                    canChangeRetire={canChangeRetire}
                                    RetireStatus={RetireStatus}
                                    items={getItems()}
                                    type={currentGrid ?? 'user'}
                                    onActionClick={(tp: string) =>
                                        onCommandBarActionClick(tp)
                                    }
                                    devicesFiltered={devicesFiltered}
                                />
                            </div>
                            <div className="linkedAccount">
                                {/* <CommandBar
                                    id="btnRepresentatives"
                                    farItems={getItems()}
                                    items={[]}
                                /> */}

                                <div className="gridViewTaxpayer">
                                    {isLoading ? (
                                        <LoadingSpinner
                                            messageLabel={t('common:Searching')}
                                        />
                                    ) : (
                                        <Pivot
                                            className="representTabs"
                                            selectedKey={currentGrid}
                                            onLinkClick={(item) => {
                                                setSelectedGrid(
                                                    item?.props?.itemKey ?? ''
                                                );
                                            }}
                                        >
                                            {hasMngRepres && (
                                                <PivotItem
                                                    itemKey="user"
                                                    headerText={t('User')}
                                                >
                                                    <UsersGrid
                                                        data={
                                                            taxpayerRepresentations?.filter(
                                                                (
                                                                    item: GetRepresentationOfTaxpayerDto
                                                                ) =>
                                                                    item.userProfileType?.toString() ===
                                                                    '1'
                                                            ) || []
                                                        }
                                                        currentLanguage={
                                                            propsCurrentLanguage
                                                        }
                                                        onActionClick={(
                                                            action: string,
                                                            item: GetRepresentationOfTaxpayerDto
                                                        ) =>
                                                            onUSERGridAction(
                                                                action,
                                                                item
                                                            )
                                                        }
                                                    />
                                                </PivotItem>
                                            )}
                                            {hasMngERP && (
                                                <PivotItem
                                                    itemKey="erp"
                                                    headerText={t('ERP')}
                                                >
                                                    <ERPGrid
                                                        items={
                                                            taxpayerRepresentations?.filter(
                                                                (
                                                                    item: GetRepresentationOfTaxpayerDto
                                                                ) =>
                                                                    item.userProfileType?.toString() ===
                                                                    '2'
                                                            ) || []
                                                        }
                                                        currentLanguage={
                                                            propsCurrentLanguage
                                                        }
                                                        onActionClick={(
                                                            action: string,
                                                            item: GetRepresentationOfTaxpayerDto
                                                        ) =>
                                                            onERPGridAction(
                                                                action,
                                                                item
                                                            )
                                                        }
                                                    />
                                                </PivotItem>
                                            )}

                                            {hasB2cTagCanMngPOS && (
                                                <PivotItem
                                                    itemKey="pos"
                                                    headerText={t('pos:POS')}
                                                >
                                                    <DevicesGrid
                                                        selectedItems={
                                                            selectedDevices
                                                        }
                                                        onSelectionChange={(
                                                            dev: CurrentDeviceListItemDto[]
                                                        ) => {
                                                            return onDevicesSelectionChanged(
                                                                dev
                                                            );
                                                        }}
                                                        onGridBind={
                                                            onDevicesGridBind
                                                        }
                                                        onGridChanged={
                                                            onGridChanged
                                                        }
                                                        reload={reload}
                                                        onRealod={() =>
                                                            setReload(false)
                                                        }
                                                        forceResetFilter={
                                                            devicesResetFilter
                                                        }
                                                        onActionClick={(
                                                            action: string,
                                                            item: CurrentDeviceListItemDto
                                                        ) =>
                                                            onActionClick(
                                                                action,
                                                                item
                                                            )
                                                        }
                                                    />
                                                </PivotItem>
                                            )}
                                            {hasMngTaxInter &&
                                                showAddIntermediaryLink && (
                                                    <PivotItem
                                                        itemKey="intermediary"
                                                        headerText={t(
                                                            'intermediaries'
                                                        )}
                                                    >
                                                        <IntermediariesGrid
                                                            items={
                                                                taxpayerIntermediaries.result
                                                            }
                                                            currentLanguage={
                                                                propsCurrentLanguage
                                                            }
                                                        />
                                                    </PivotItem>
                                                )}
                                        </Pivot>
                                    )}
                                </div>
                                {showDeactivateDialog && (
                                    <StatusDialog
                                        multiple={selectMultiple}
                                        data={
                                            selectMultiple
                                                ? selectedDevices
                                                : currentDevice
                                        }
                                        onSave={() => ChangeStatus()}
                                        onClose={() => {
                                            setSelectMultiple(false);
                                            setShowDeactivateDialog(false);
                                        }}
                                    />
                                )}

                                {showRetireDialog && (
                                    <RetireDialog
                                        multiple={selectMultiple}
                                        data={
                                            selectMultiple
                                                ? selectedDevices
                                                : currentDevice
                                        }
                                        onClose={() => {
                                            setSelectMultiple(false);
                                            setShowRetireDialog(false);
                                        }}
                                        hidden={showRetireDialog}
                                        onSave={() => {
                                            setShowRetireDialog(false);
                                            setReload(true);
                                        }}
                                    />
                                )}
                                {showRegenerateSecrets && (
                                    <RegenerateDeviceSecrets
                                        id={currentDevice?.id ?? 0}
                                        hidden={!showRegenerateSecrets}
                                        currentLanguage={propsCurrentLanguage}
                                        onClose={() =>
                                            setShowRegenerateSecrets(false)
                                        }
                                        onSave={() => {
                                            setShowRegenerateSecrets(false);
                                        }}
                                    />
                                )}
                                {!hideInviteUser && (
                                    <RepresentationProvider>
                                        <InviteUserMain
                                            hidden={hideInviteUser}
                                            onClose={() =>
                                                hideInviteUserDialog(true)
                                            }
                                            language={
                                                currentProfileLanguage as LanguageTypes
                                            }
                                            onSuccessAction={(action) =>
                                                saveAction(action)
                                            }
                                            mode={mode}
                                            representationID={
                                                representationID.current
                                            }
                                            clientId={
                                                representationData.clientID
                                            }
                                        />
                                    </RepresentationProvider>
                                )}
                                {!hideNotifications && (
                                    <NotificationPreferences
                                        hidden={hideNotifications}
                                        onClose={() =>
                                            hideNotificationsDialog(true)
                                        }
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.NotificationPreferences
                                            )
                                        }
                                        notifications={
                                            currentNotifications.result &&
                                            currentNotifications.result[0]
                                        }
                                    />
                                )}
                                {!hideAddERP && (
                                    <AddERP
                                        hidden={hideAddERP}
                                        onClose={() => hideAddERPDialog(true)}
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.AddERP
                                            )
                                        }
                                        language={currentProfile.language}
                                        rin={
                                            authService.currentUser?.profile
                                                .TaxRin
                                        }
                                    />
                                )}
                                {!hideAddIntermediary && (
                                    <ManageIntermediary
                                        hidden={hideAddIntermediary}
                                        onClose={() =>
                                            HideAddIntermediaryDialog(true)
                                        }
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.AddIntermediary
                                            )
                                        }
                                    />
                                )}
                                <EditERP
                                    hidden={hideEditERP}
                                    onClose={() => hideEditERPDialog(true)}
                                    onSave={() =>
                                        saveAction(
                                            TaxpayerProfileActions.EditERP
                                        )
                                    }
                                    erpData={representationData}
                                />
                                {!hideSecrets && (
                                    <RegenerateSecrets
                                        hidden={hideSecrets}
                                        onClose={() => hideSecretsDialog(true)}
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.RegenerateSecrets
                                            )
                                        }
                                        erpData={representationData}
                                        currentLanguage={propsCurrentLanguage}
                                    />
                                )}
                                {!hideVerifyEmail && (
                                    <Email
                                        hidden={hideVerifyEmail}
                                        onClose={() => {
                                            hideVerifyEmailDialog(true);
                                        }}
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.VerifyEmail
                                            )
                                        }
                                        NewEmail={currentProfile.email}
                                        Type="TaxPayer"
                                        preferredLanguage={
                                            currentProfileLanguage ===
                                            LanguagesCodes.En
                                                ? LanguageTypes.En
                                                : LanguageTypes.Ar
                                        }
                                    />
                                )}
                                {!hideVerifyMobile && (
                                    <Mobile
                                        hidden={hideVerifyMobile}
                                        onClose={() => {
                                            hideVerifyMobileDialog(true);
                                        }}
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.VerifyMobile
                                            )
                                        }
                                        NewMobile={currentProfile.mobileNo}
                                        Type="TaxPayer"
                                        preferredLanguage={
                                            currentProfileLanguage ===
                                            LanguagesCodes.En
                                                ? LanguageTypes.En
                                                : LanguageTypes.Ar
                                        }
                                    />
                                )}
                                {!hideVerifyMobileAndEmail && (
                                    <EmailMobile
                                        hidden={hideVerifyMobileAndEmail}
                                        onClose={() => {
                                            hideVerifyMobileAndEmailDialog(
                                                true
                                            );
                                        }}
                                        onSave={() =>
                                            saveAction(
                                                TaxpayerProfileActions.VerifyEmailMobile
                                            )
                                        }
                                        NewEmail={currentProfile.email}
                                        NewMobile={currentProfile.mobileNo}
                                        Type="TaxPayer"
                                        preferredLanguage={
                                            currentProfileLanguage ===
                                            LanguagesCodes.En
                                                ? LanguageTypes.En
                                                : LanguageTypes.Ar
                                        }
                                    />
                                )}
                                {!hideBlockUSER && (
                                    <BlockUser
                                        hidden={hideBlockUSER}
                                        onClose={() => setHideBlockUSER(true)}
                                        onSave={(request) => blockUSER(request)}
                                        UserData={representationData}
                                    />
                                )}
                            </div>
                        </div>
                    </PivotItem>
                    <PivotItem headerText={t('branches')}>
                        <Panel
                            title={t('form.TaxPayer.ContactBranches')}
                            allowEdition={false}
                            editable={isBranchEditable}
                            editTitle={t('edit')}
                            editText={t('common:edit')}
                            onChangeEdit={onChangeBranchEdit}
                        >
                            <div>
                                <div className="bodyLine branchesInfo">
                                    <VirtualizedComboBox
                                        selectedKey={selectedBranch}
                                        options={taxpayerBranches ?? []}
                                        label={t(
                                            'form.TaxPayer.SelectBranches'
                                        )}
                                        onChange={(_, option) =>
                                            onChangeBranch(
                                                Number(option?.key) ?? 0
                                            )
                                        }
                                        readOnly={isBranchEditable}
                                    />
                                    <TextField
                                        label={t('UserProfile.MobileNumber')}
                                        value={currentBranch?.sourcePhoneNumber}
                                        disabled
                                    />
                                    <TextField
                                        label={t('common:isPrimary')}
                                        value={
                                            currentBranch?.isMainBranch
                                                ? t('common:yes')
                                                : t('common:no')
                                        }
                                        disabled
                                    />
                                    <TextField
                                        label={t(
                                            'resources:form-components.Status'
                                        )}
                                        value={`${
                                            CheckIFActiveBranch(
                                                currentBranch?.branchStartDate,
                                                currentBranch?.branchCeaseDate
                                            )
                                                ? t('resources:Active')
                                                : t('resources:InActive')
                                        }(${UIHelpers.getLocalizedDateTime(
                                            'Date',
                                            currentBranch?.branchStartDate,
                                            propsCurrentLanguage.langIso4
                                        )} - ${UIHelpers.getLocalizedDateTime(
                                            'Date',
                                            currentBranch?.branchCeaseDate,
                                            propsCurrentLanguage.langIso4
                                        )})`}
                                        className={
                                            CheckIFActiveBranch(
                                                currentBranch?.branchStartDate,
                                                currentBranch?.branchCeaseDate
                                            )
                                                ? 'green'
                                                : 'inActive'
                                        }
                                        disabled
                                    />
                                    {/* <TextField
                                        label={t('form.TaxPayer.PopulatedAddress')}
                                        value={currentBranch?.sourceAddress}
                                        disabled
                                        className="address"

                                    /> */}
                                </div>
                                <div className="bodyLine addressInfo">
                                    <TextField
                                        label={t('form.TaxPayer.Address')}
                                        value={formattedAddress(
                                            currentBranch?.address
                                        )}
                                        disabled
                                        className="address"
                                        toolTip={t('ToolTip.FormatedAddress')}
                                    />
                                </div>
                                {!isBranchEditable ||
                                taxpayerBranches?.length === 0 ? null : (
                                    <div className="no_panel">
                                        <EditAddress
                                            onClose={() =>
                                                onChangeBranchEdit(false)
                                            }
                                            saveAddress={(
                                                address?: GetTaxpayerAddressDto,
                                                branchName?: string
                                            ) => saveForm(address, branchName)}
                                            branch={currentBranch}
                                        />
                                    </div>
                                )}
                            </div>
                        </Panel>
                        <Panel
                            allowEdition={false}
                            editable={false}
                            title={t('activityCode')}
                        >
                            <ActivityCodeGrid
                                currentLanguage={currentLanguage}
                                items={taxpayerActivity}
                            />
                        </Panel>
                    </PivotItem>

                    {isIntermediary && showAddIntermediaryLink && (
                        <PivotItem headerText={t('intermediaryDetails')}>
                            <IntermediaryDetails
                                isTaxpayerAllowed={currentProfile.isActive}
                            />
                        </PivotItem>
                    )}
                    {showAddIntermediaryLink &&
                        !isIntermediary &&
                        intermediaryStatus === ApplicationStatuses.Pending && (
                            <PivotItem headerText={t('intermediaryDetails')}>
                                <div className="applicationStatus">
                                    <Icon iconName="ProgressRingDots" />
                                    <span>{t('ApplicationInProgress')}</span>
                                </div>
                            </PivotItem>
                        )}
                    {showAddIntermediaryLink &&
                        !isIntermediary &&
                        intermediaryStatus === ApplicationStatuses.Rejected && (
                            <PivotItem headerText={t('intermediaryDetails')}>
                                <div className="applicationStatus">
                                    <Icon iconName="Blocked2Solid" />
                                    <span>{t('ApplicationRejected')}</span>
                                </div>
                            </PivotItem>
                        )}
                </Pivot>

                {registerAsIntermediary &&
                    ClaimsHelper.hasPermission(PermissionClaim.MngContact) && (
                        <div className="register">
                            <ActionButton
                                className="history"
                                iconProps={{ iconName: 'Send' }}
                                onClick={() => {
                                    dispatchChangeAppSatusAction(false);

                                    history.push(
                                        '/TaxpayerProfile/RegisterIntermediary'
                                    );
                                }}
                            >
                                {t('RegisterAsIntermediary')}
                            </ActionButton>
                        </div>
                    )}
            </div>
            {showBulkDialog && (
                <DeviceBulkUpload
                    hidden={!showBulkDialog}
                    onStartProcessing={(data, ishidden) =>
                        setShowBulkDialog(!ishidden)
                    }
                />
            )}
        </LayoutContent>
    );
};

export default connector(TaxpayerProfile);
